// List of all weather stations
import Leaflet from 'leaflet';

//#region tide icon maker and corresponding color function
export function tideMarker(tide: string): Leaflet.DivIcon {
    if (tide === "M")
    {
        return Leaflet.divIcon({
            className: 'number-icon',
            html: `<div style="background-color: ${setColorOfTide(tide)}; margin: 0px; color:white;">M</div>`,
            iconSize: setTiderMarkerIconSize(tide)
        });
    }

    tide = supplementZero(tide)
    var tideFloat:number = parseFloat(tide);

    return Leaflet.divIcon({
        className: 'number-icon',
        html: `<div style="background-color: ${setColorOfTide(tide)}; margin: 0px; color:${setColorOfTideText(tideFloat)};">${tide}m</div>`,
        iconSize: setTiderMarkerIconSize(tide)
    });
};

function setColorOfTide(tide: string): string {
  var result:string = "";
  var tideFloat:number = parseFloat(tide);

  switch (true) {
    case (tideFloat >= 5.0):
      result = "black";
      break;
    case (tideFloat >= 4.0):
      result = "#FF00FF";
      break;
    case (tideFloat >= 3.0):
      result = "red";
      break;
    case (tideFloat >= 2.5):
      result = "orange";
      break;
    case (tideFloat >= -1.0):
      result = "gray";
      break;
    default:
      result = "gray";
      break;
  }
  return result;
}

function setColorOfTideText(tide: number): string {
    return "white";
    // switch (true) {
    //     case (tide >= 5.0):
    //     return "white";
    //     case (tide >= 4.0):
    //     return "white";
    //     case (tide >= 3.0):
    //     return "white";
    //     case (tide >= 2.5):
    //     return "white";
    //     case (tide >= -1.0):
    //     return "white";
    //     default:
    //     return "white";
    // }
}

function setTiderMarkerIconSize(tideStr: string): Leaflet.PointExpression {
    switch (true) {
        case (tideStr?.length === 1):
            return [21, 25];
        case (tideStr?.length === 2):
            return [30, 25];
        case (tideStr?.length >= 3):
            return [44, 25];
        default:
            return [21, 25];
    }
}

function supplementZero(tideStr: string): string
{
    switch (true)
    {
        case tideStr?.length === 1:
            return tideStr+".00";
        case tideStr?.length === 3:
            return tideStr+"0";
        default:
            return tideStr;
    }
}
//#endregion